import { render, staticRenderFns } from "./OVO.vue?vue&type=template&id=0fe08d4e&scoped=true"
import script from "./OVO.vue?vue&type=script&lang=js"
export * from "./OVO.vue?vue&type=script&lang=js"
import style0 from "./OVO.vue?vue&type=style&index=0&id=0fe08d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe08d4e",
  null
  
)

export default component.exports